import { render, staticRenderFns } from "./support.vue?vue&type=template&id=77c8eb22&"
import script from "./support.vue?vue&type=script&lang=js&"
export * from "./support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c8eb22')) {
      api.createRecord('77c8eb22', component.options)
    } else {
      api.reload('77c8eb22', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=77c8eb22&", function () {
      api.rerender('77c8eb22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support.vue"
export default component.exports